/** Check if items in array match the regular expression */
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function arrayPatternValidator(regExp: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value as string[];
    let forbidden = false;

    if (controlValue.length > 0) {
      controlValue.forEach(item => {
        if (!regExp.test(item)) {
          forbidden = true;
        }
      });
    }

    return forbidden ? {emailsList: {value: control.value}} : null;
  };
}